// should pass date as a string not convert it here

import moment from 'moment';

export function formate(dateAsString: string): string {
  const formattedDate = moment(dateAsString).format('dddd, MMM D hh:mm a');
  return formattedDate;
}
